import type { NDateLocale } from './enUS'
import { nb } from 'date-fns/locale'

const dateNbNO: NDateLocale = {
  name: 'nb-NO',
  locale: nb
}

export default dateNbNO
